// extracted by mini-css-extract-plugin
module.exports = {"StatCounterWidget":"styles_StatCounterWidget__TvUIv"};